import { render, staticRenderFns } from "./select-resource.vue?vue&type=template&id=3e5dc6cf&scoped=true"
import script from "./select-resource.vue?vue&type=script&lang=js"
export * from "./select-resource.vue?vue&type=script&lang=js"
import style0 from "./select-resource.vue?vue&type=style&index=0&id=3e5dc6cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5dc6cf",
  null
  
)

export default component.exports